import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getVerticalUserCount, adminDashboard, schoolCount,tuitionCount, preschoolCount, afaCount, learningcampCount} from '../../API/FetchCall';

import AmCharts from "@amcharts/amcharts3-react";

// Generate random data
function generateData() {
  var firstDate = new Date();

  var dataProvider = [];

  for (var i = 0; i < 100; ++i) {

    var date = new Date(firstDate.getTime());

    date.setDate(i);

    dataProvider.push({
      date: date,
      value: Math.floor(Math.random() * 100)
    });

  }

  return dataProvider;
}

class reportV2 extends Component {

  constructor(props) {
      super(props);
      this.state = {
          timer: null,
          dataProvider: generateData(),
      };
  }

  componentDidMount() {

    this.setState({
        // Update the chart dataProvider every 3 seconds
        timer: setInterval(() => {
          this.setState({
            dataProvider: generateData()
          });
        }, 3000)
      });
   
  }

  componentWillUnmount() {
    clearInterval(this.state.timer);
  }

  render() {

    const config_xy = {
        "type": "xy",
        "theme": "none",
        "marginRight": 80,
        "dataDateFormat": "YYYY-MM-DD",
        "startDuration": 1.5,
        "trendLines": [],
        "balloon": {
          "adjustBorderColor": false,
          "shadowAlpha": 0,
          "fixedPosition": true
        },
        "graphs": [{
          "balloonText": "<div style='margin:5px;'><b>[[x]]</b><br>y:<b>[[y]]</b><br>value:<b>[[value]]</b></div>",
          "bullet": "diamond",
          "maxBulletSize": 25,
          "lineAlpha": 0.8,
          "lineThickness": 2,
          "lineColor": "#b0de09",
          "fillAlphas": 0,
          "xField": "date",
          "yField": "ay",
          "valueField": "aValue"
        }, {
          "balloonText": "<div style='margin:5px;'><b>[[x]]</b><br>y:<b>[[y]]</b><br>value:<b>[[value]]</b></div>",
          "bullet": "round",
          "maxBulletSize": 25,
          "lineAlpha": 0.8,
          "lineThickness": 2,
          "lineColor": "#fcd202",
          "fillAlphas": 0,
          "xField": "date",
          "yField": "by",
          "valueField": "bValue"
        }],
        "valueAxes": [{
          "id": "ValueAxis-1",
          "axisAlpha": 0
        }, {
          "id": "ValueAxis-2",
          "axisAlpha": 0,
          "position": "bottom"
        }],
        "allLabels": [],
        "titles": [],
        "dataProvider": [{
          "date": 1,
          "ay": 6.5,
          "by": 2.2,
          "aValue": 15,
          "bValue": 10
        }, {
          "date": 2,
          "ay": 12.3,
          "by": 4.9,
          "aValue": 8,
          "bValue": 3
        }, {
          "date": 3,
          "ay": 12.3,
          "by": 5.1,
          "aValue": 16,
          "bValue": 4
        }, {
          "date": 5,
          "ay": 2.9,
          "aValue": 9
        }, {
          "date": 7,
          "by": 8.3,
          "bValue": 13
        }, {
          "date": 10,
          "ay": 2.8,
          "by": 13.3,
          "aValue": 9,
          "bValue": 13
        }, {
          "date": 12,
          "ay": 3.5,
          "by": 6.1,
          "aValue": 5,
          "bValue": 2
        }, {
          "date": 13,
          "ay": 5.1,
          "aValue": 10
        }, {
          "date": 15,
          "ay": 6.7,
          "by": 10.5,
          "aValue": 3,
          "bValue": 10
        }, {
          "date": 16,
          "ay": 8,
          "by": 12.3,
          "aValue": 5,
          "bValue": 13
        }, {
          "date": 20,
          "by": 4.5,
          "bValue": 11
        }, {
          "date": 22,
          "ay": 9.7,
          "by": 15,
          "aValue": 15,
          "bValue": 10
        }, {
          "date": 23,
          "ay": 10.4,
          "by": 10.8,
          "aValue": 1,
          "bValue": 11
        }, {
          "date": 24,
          "ay": 1.7,
          "by": 19,
          "aValue": 12,
          "bValue": 3
        }],
      
        "export": {
          "enabled": true
        },
      
        "chartScrollbar": {
          "offset": 15,
          "scrollbarHeight": 5
        },
      
        "chartCursor": {
          "pan": true,
          "cursorAlpha": 0,
          "valueLineAlpha": 0
        }
    }

    const config_donut = {
        "type": "pie",
        "theme": "none",
        "dataProvider": [ {
          "country": "Lithuania",
          "value": 260
        }, {
          "country": "Ireland",
          "value": 201
        }, {
          "country": "Germany",
          "value": 65
        }, {
          "country": "Australia",
          "value": 39
        }, {
          "country": "UK",
          "value": 19
        }, {
          "country": "Latvia",
          "value": 10
        } ],
        "valueField": "value",
        "titleField": "country",
        "outlineAlpha": 0.4,
        "depth3D": 15,
        "balloonText": "[[title]]<br><span style='font-size:14px'><b>[[value]]</b> ([[percents]]%)</span>",
        "angle": 30,
        "export": {
          "enabled": true
        }
                }

    const config = {
        "type": "serial",
        "theme": "light",
        "dataProvider": [ {
            "country": "USA",
            "visits": 2025
          }, {
            "country": "China",
            "visits": 1882
          }, {
            "country": "Japan",
            "visits": 1809
          }, {
            "country": "Germany",
            "visits": 1322
          }, {
            "country": "UK",
            "visits": 1122
          }, {
            "country": "France",
            "visits": 1114
          }, {
            "country": "India",
            "visits": 984
          }, {
            "country": "Spain",
            "visits": 711
          }, {
            "country": "Netherlands",
            "visits": 665
          }, {
            "country": "Russia",
            "visits": 580
          }, {
            "country": "South Korea",
            "visits": 443
          }, {
            "country": "Canada",
            "visits": 441
          }, {
            "country": "Brazil",
            "visits": 395
          } ],
          "valueAxes": [ {
            "gridColor": "#393999",
            "gridAlpha": 0.2,
            "dashLength": 0
          } ],
          "gridAboveGraphs": true,
          "startDuration": 1,
          "graphs": [ {
            "balloonText": "[[category]]: <b>[[value]]</b>",
            "fillAlphas": 0.8,
            "lineAlpha": 0.2,
            "type": "column",
            "valueField": "visits"
          } ],
          "chartCursor": {
            "categoryBalloonEnabled": false,
            "cursorAlpha": 0,
            "zoomable": false
          },
          "categoryField": "country",
          "categoryAxis": {
            "gridPosition": "start",
            "gridAlpha": 0,
            "tickPosition": "start",
            "tickLength": 20
          },
          "export": {
            "enabled": true
          }
        
      };


      
      const config_enq_report  = {
        "type": "serial",
        "theme": "light",
        "dataProvider": [ {
            "month": "Jan",
            "enquiries": 40
          }, {
            "month": "Feb",
            "enquiries": 20
          }, {
            "month": "Mar",
            "enquiries": 18
          }, {
            "month": "Apr",
            "enquiries": 15
          }, {
            "month": "May",
            "enquiries": 25
          }
        ]
        ,
          "valueAxes": [ {
            "gridColor": "#EAE35E",
            "gridAlpha": 0.2,
            "dashLength": 0
          } ],
          "gridAboveGraphs": true,
          "startDuration": 1,
          "graphs": [ {
            "balloonText": "[[category]]: <b>[[value]]</b>",
            "fillAlphas": 0.8,
            "fillColors": "#0766AD",
            "lineAlpha": 0.2,
            "type": "column",
            "valueField": "enquiries"
          } ],
          "chartCursor": {
            "categoryBalloonEnabled": false,
            "cursorAlpha": 0,
            "zoomable": false
          },
          "categoryField": "month",
          "categoryAxis": {
            "gridPosition": "start",
            "gridAlpha": 0,
            "tickPosition": "start",
            "tickLength": 20
          },
          "export": {
            "enabled": false
          }
      }

      const config_visits_month = {
        "type": "serial",
        "theme": "light",
        "dataProvider": [ {
            "month": "Jan",
            "visits": 40
          }, {
            "month": "Feb",
            "visits": 20
          }, {
            "month": "Mar",
            "visits": 18
          }, {
            "month": "Apr",
            "visits": 15
          }, {
            "month": "May",
            "visits": 5
          },
          {
            "month": "Jun",
            "visits": 50
          },
          {
            "month": "July",
            "visits": 35
          },
          {
            "month": "Aug",
            "visits": 12
          },
          {
            "month": "Sep",
            "visits": 98
          },
          {
            "month": "Oct",
            "visits": 4
          },
          {
            "month": "Nov",
            "visits": 46
          },
          {
            "month": "Dec",
            "visits": 33
          }
        ]
        ,
          "valueAxes": [ {
            "gridColor": "#EAE35E",
            "gridAlpha": 0.2,
            "dashLength": 0
          } ],
          "gridAboveGraphs": true,
          "startDuration": 1,
          "graphs": [ {
            "balloonText": "[[category]]: <b>[[value]]</b>",
            "fillAlphas": 0.6,
            "fillColors": "#0766AD",
            "lineAlpha": 0.3,
            "type": "column",
            "valueField": "visits"
          } ],
          "chartCursor": {
            "categoryBalloonEnabled": false,
            "cursorAlpha": 0,
            "zoomable": false
          },
          "categoryField": "month",
          "categoryAxis": {
            "gridPosition": "start",
            "gridAlpha": 0,
            "tickPosition": "start",
            "tickLength": 20
          },
          "export": {
            "enabled": false
          }
      }

      
    return (

        <React.Fragment>
        <AdminLayout>
            
                <div class="row  mt-3">
                    <div class="col-xl-12 d-flex grid-margin stretch-card">
                      <div class="card">
                        <div class="card-body">
                          <div class="d-flex flex-wrap justify-content-between">
                            <h4 class="card-title mb-3">Visual Reports</h4>
                          </div>
                          <div class="row">
                            <div class="col-6">
                               
                                <div class="graphtitle">Visits By Month 2023</div> 
                                <div class="innerchart">
                                  <AmCharts.React style={{ width: "100%", height: "500px" }} options={config_visits_month} />
                                </div>

                            </div>
                            <div class="col-6">

                                 <div class="graphtitle">Sample Title</div> 
                                 <div class="innerchart">
                                  <AmCharts.React style={{ width: "100%", height: "500px" }} options={config_donut} />
                                 </div>

                            </div>
                            <div class="col-6">

                               <div class="graphtitle">Monthly View Your Page visit</div> 
                               <div class="innerchart">
                                <AmCharts.React style={{ width: "100%", height: "500px" }} options={config_xy} />
                               </div>
                            </div>

                            <div class="col-6">

                               <div class="graphtitle">Enquiry Report per month</div> 
                               <div class="innerchart">
                                <AmCharts.React style={{ width: "100%", height: "500px" }} options={config_enq_report} />
                               </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                </div>
    
        </AdminLayout>
    </React.Fragment>

      
    );
  }
}

export default reportV2;


// WEBPACK FOOTER //
// ./src/components/bewise/reportV2.jsx